<template>
  <div
    class="with-before-container"
    :class="[
      content.leftMark.type === 'block' ? 'container-block' : '',
      content.leftMark.type === 'inline' ? 'container-inline' : '',
      content.leftMark.type === 'flex' ? 'container-flex' : '',
    ]"
    :id="content.key"
    :style="{
      fontFamily: content.paragraphStyle.fontFamily || '',
      fontSize: (content.paragraphStyle.fontSize + 'rem') || '',
      lineHeight: (content.paragraphStyle.lineHeight + 'rem') || '',
      textIndent: (content.paragraphStyle.textIndent && typeof content.paragraphStyle.textIndent === 'string') ? content.paragraphStyle.textIndent :
        (content.paragraphStyle.textIndent && typeof content.paragraphStyle.textIndent === 'number') ? (content.paragraphStyle.textIndent + 'rem') : '',
      fontWeight: content.paragraphStyle.fontWeight || '',
      textDecoration: content.paragraphStyle.underline === 1 ? 'underline' : '',
      fontStyle: content.paragraphStyle.fontItalic === 1 ? 'italic' : '',
      textAlign: content.paragraphStyle.textAlign || '',
      color: content.paragraphStyle.color || '',
      backgroundColor: content.paragraphStyle.backgroundColor || '',
      marginTop: (typeof content.paragraphStyle.marginTop === 'number' && (content.paragraphStyle.marginTop + 'rem')) || '',
      marginBottom: (typeof content.paragraphStyle.marginBottom === 'number' && (content.paragraphStyle.marginBottom + 'rem')) || '',
      padding: (typeof content.paragraphStyle.padding === 'number' && (content.paragraphStyle.padding + 'rem')) || '',
      paddingLeft: (typeof content.paragraphStyle.paddingLeft === 'number' && (content.paragraphStyle.paddingLeft + 'rem')) || '',
      paddingRight: (typeof content.paragraphStyle.paddingRight === 'number' && (content.paragraphStyle.paddingRight + 'rem')) || '',
    }"
  >
    <div
      class="with-before"
      :id="`${content.key}-1`"
      :style="{
        flex: (typeof content.leftMark.width === 'number' && (`0 0 ${content.leftMark.width}rem`)) || '',
        width: (typeof content.leftMark.width === 'number' && (content.leftMark.width + 'rem')) || '',
        height: (typeof content.leftMark.height === 'number' && (content.leftMark.height + 'rem')) || '',
        fontFamily: content.leftMark.textStyle.fontFamily || '',
        fontSize: (content.leftMark.textStyle.fontSize + 'rem') || '',
        lineHeight: (content.leftMark.textStyle.lineHeight + 'rem') || '',
        textIndent: (content.leftMark.textStyle.textIndent && typeof content.leftMark.textStyle.textIndent === 'string') ? content.leftMark.textStyle.textIndent :
          (content.leftMark.textStyle.textIndent && typeof content.leftMark.textStyle.textIndent === 'number') ? (content.leftMark.textStyle.textIndent + 'rem') : '',
        fontWeight: content.leftMark.textStyle.fontWeight || '',
        textDecoration: content.leftMark.textStyle.underline === 1 ? 'underline' : '',
        fontStyle: content.leftMark.textStyle.fontItalic === 1 ? 'italic' : '',
        textAlign: content.leftMark.textStyle.textAlign || '',
        color: content.leftMark.textStyle.color || '',
        backgroundColor: content.leftMark.textStyle.backgroundColor || '',
        backgroundImage: content.leftMark.textStyle.backgroundImage ? `url(${content.leftMark.textStyle.backgroundImage})` : '',
        paddingLeft: (typeof content.leftMark.textStyle.paddingLeft === 'number' && (content.leftMark.textStyle.paddingLeft + 'rem')) || '',
        paddingRight: (typeof content.leftMark.textStyle.paddingRight === 'number' && (content.leftMark.textStyle.paddingRight + 'rem')) || '',
        marginLeft: (typeof content.leftMark.textStyle.marginLeft === 'number' && (content.leftMark.textStyle.marginLeft + 'rem')) || '',
        marginRight: (typeof content.leftMark.textStyle.marginRight === 'number' && (content.leftMark.textStyle.marginRight + 'rem')) || '',
        marginTop: (typeof content.leftMark.textStyle.marginTop === 'number' && (content.leftMark.textStyle.marginTop + 'rem')) || '',
        marginBottom: (typeof content.leftMark.textStyle.marginBottom === 'number' && (content.leftMark.textStyle.marginBottom + 'rem')) || '',
        top: (typeof content.leftMark.textStyle.top === 'number' && (content.leftMark.textStyle.top + 'rem')) || '',
        left: (typeof content.leftMark.textStyle.left === 'number' && (content.leftMark.textStyle.left + 'rem')) || '',
      }"
    >
      {{ content.leftMark.text }}
      <div class="pop-box" v-if="content.leftMark.popContent">
        <popover :content="content.leftMark.popContent">
          <template #popContent>
            <div class="pop-icon"></div>
          </template>
        </popover>
      </div>
    </div>
    <div
      class="with-content"
      :id="`${content.key}-1`"
    >
      <textIndex :content="content.content" :isInTable="true"></textIndex>
    </div>
  </div>
</template>
<script>
/*
带标头的组件
*/
import textIndex from "../text/index.vue";
import popover from "../text/popover.vue";
export default {
  name: "withBefore",
  components: {
    textIndex,
    popover,
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data() {
    return {
      
    }
  },
  mounted() {
    
  },
  methods: {
    
  }
}
</script>
<style lang="scss" scoped>
.with-before-container.container-block{
  display: flex;
  align-items: flex-start;

  .with-before{
    position: relative;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    text-align: center;

    .pop-box{
      width: 44rem;
      height: 44rem;
      position: absolute;
      bottom: -44rem;
      left: -2rem;

      .pop-icon{ 
        width: 44rem;
        height: 44rem;
        background: url(~@/assets/images/books/book2/key-icon.png) center center no-repeat;
        background-size: contain;
      }
    }
  }
  .with-content{
    font-size: 28rem;
    line-height: 38rem;
    width:100%;
  }
}
.with-before-container.container-flex{
  display: flex;

  .with-before{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.with-before-container.container-inline{
  position: relative;

  .with-before{
    position: absolute;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    text-align: center;
  }
}
</style>